import React from 'react'
import Content from '../components/Content'

export default function Menu() {
    return (
        <div>
            <Content />
        </div>
    )
}
